export default __webpack_public_path__ + "static/media/vip10.7a4395f1.webp";